import React from 'react';
import Building from '../assets/building.png'; // Adjust the path if necessary
import companyLogo from '../assets/companylogo.gif'; // Adjust the path if necessary

// global function to handle smooth scrolling
const handleScroll = (event, targetId) => {
  event.preventDefault();
  const targetElement = document.getElementById(targetId);
  if (targetElement) {
    targetElement.scrollIntoView({ behavior: 'smooth' });
  }
};

const Hero = () => {
  return (
    <section id="hero" className="bg-navy text-white py-24 md:py-32">
      <div className="container mx-auto flex flex-col md:flex-row items-center justify-between space-y-8 md:space-y-0 px-4 md:px-8">
        {/* Left Column: Text and Logo */}
        <div className="flex flex-col items-center md:items-start md:w-1/2 space-y-6 text-center md:text-left">
          {/* Company Logo */}
          <div className="w-32 h-32 p-3 bg-white border border-white/20 mx-auto md:mx-0">
            <img
              src={companyLogo}
              alt="Company Logo"
              className="w-full h-full object-contain"
            />
          </div>

          <p className="text-xs font-semibold uppercase tracking-[0.2em] text-gold-light">
            Licensed Insurance Broker &middot; Belize City
          </p>

          {/* Headline */}
          <h1 className="font-serif text-3xl md:text-4xl font-semibold leading-tight tracking-tight">
            Your Trusted Partner in Protection <br />
            <span className="text-gold-light">
              Customized Insurance Solutions for You & Your Business
            </span>
          </h1>

          {/* Description */}
          <p className="text-base md:text-lg text-gray-300 leading-relaxed px-4 md:px-0">
            As independent brokers, we work closely with Belize's leading insurers to compare
            coverage and match you with the right policy at the right price.
          </p>

          {/* Call-to-Action Buttons */}
          <div className="mt-8 flex flex-col md:flex-row md:space-x-4 space-y-3 md:space-y-0">
            <a
              href="#inquiry"
              className="bg-gold-light hover:bg-gold-light text-navy-dark text-sm font-semibold uppercase tracking-wider py-3 px-6 transition-colors duration-200 text-center"
              onClick={(e)=>handleScroll(e, 'inquiry')}
            >
              Send an Inquiry
            </a>
            <a
              href="#about"
              className="bg-transparent border border-white/40 hover:border-gold hover:text-gold-light text-white text-sm font-semibold uppercase tracking-wider py-3 px-6 transition-colors duration-200 text-center"
              onClick={(e)=>handleScroll(e, 'about')}
            >
              Learn More
            </a>
          </div>
        </div>

        {/* Right Column: Building Image */}
        <div className="md:w-1/2 flex justify-center items-center">
          <div className="relative w-full max-w-md lg:max-w-xl border border-white/20 p-2">
            <img
              src={Building}
              alt="Insurance Office Building"
              className="w-full h-full object-cover"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
